import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

const { Types, Creators } = createActions({
  setLoading: ['val'],
  fetchPayLaterOrders: ['startFrom', 'endAt'],
  setRestaurants: ['data'],
  setAllRestaurants: ['data'],
  saveMerchantSettlement: ['id', 'data', 'startFrom', 'endAt', 'callBack'],
  setSaving: ['val'],
  setMerchantSettlements: ['data'],
  paidMerchant: ['merchantSettlement', 'restaurant', 'branch'],
  syncMerchantSettlements: null
})

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  allRestaurantsLoaded: false,
  data: {},
  restaurants: {},
  allRestaurants: {},
  saving: false
})

export const setLoadingReducer = (state, { val }) => state.set('loading', val)

export const setAllRestaurantsReducer = (state, { data }) => state.set('allRestaurants', data).set('allRestaurantsLoaded', true)

export const setRestaurantsReducer = (state, { data }) => state.set('restaurants', data)

export const setSavingReducer = (state, { val }) => state.set('saving', val)

export const paidMerchantReducer = (state, { val }) => state.set('saving', val)

export const setMerchantSettlementsReducer = (state, { data }) => state.set('data', data).set('loaded', true)

export const merchantSettlementReducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADING]: setLoadingReducer,
  [Types.SET_RESTAURANTS]: setRestaurantsReducer,
  [Types.SET_ALL_RESTAURANTS]: setAllRestaurantsReducer,
  [Types.SET_SAVING]: setSavingReducer,
  [Types.SET_MERCHANT_SETTLEMENTS]: setMerchantSettlementsReducer,
  [Types.PAID_MERCHANT]: paidMerchantReducer
})

export const MerchantSettlementTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/merchantSettlementReducer.js